import { tapsBackConfig } from '@/lib/analytics/kpis/instagram/stories/tapsBack';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const tapsBackMVConfig = {
    ...tapsBackConfig,
    id: 'taps_back',
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
